import { captureException } from "@sentry/nextjs";

interface StakeInfos {
  mSolApy: { twoWeeks: number; month: number; quarter: number; year: number };
  directedStake: { distribution: number; votes: number };
}

export async function fetchStakeInfos(): Promise<StakeInfos | undefined> {
  try {
    const response = await fetch("https://api2.marinade.finance/metrics_json");

    if (!response.ok) {
      throw new Error(`${response.statusText} /// ${response.status}`);
    }

    const result = await response.json();
    return {
      mSolApy: {
        twoWeeks: result.msol_price_apy_14d,
        month: result.msol_price_apy_30d,
        quarter: result.msol_price_apy_90d,
        year: result.msol_price_apy_365d,
      },
      directedStake: {
        distribution: result.msol_directed_stake_sol,
        votes: result.msol_directed_stake_msol,
      },
    };
  } catch (err) {
    captureException(err);
    return undefined;
  }
}
